import React from 'react'
import { IoMdCloseCircleOutline } from 'react-icons/io'
import {
  MdDirectionsRun,
  MdDoNotDisturbAlt,
  MdOutlineBackHand,
  MdOutlineCheckCircle,
  MdOutlineWatchLater,
} from 'react-icons/md'

import { ESurveyHistoryStatus } from '@/libs/apis/queries/use-get-list-survey-history-query'
import enumToString from '@/libs/helpers/enum-to-string'

type TSurveyHistroyStatus = {
  readonly status: ESurveyHistoryStatus
}

export default function SurveyHistroyStatus({ status }: TSurveyHistroyStatus) {
  const statusMapping = {
    IN_PROGRESS: {
      label: 'In Progress',
      logo: <MdDirectionsRun className='h-3 w-3 text-pop-orange-400' />,
      bgClass: 'bg-pop-orange-50',
      textClass: 'text-pop-orange-400',
    },
    IN_REVIEW: {
      label: 'In Review',
      logo: <MdOutlineWatchLater className='h-3 w-3 text-pop-blue-700' />,
      bgClass: 'bg-pop-blue-100',
      textClass: 'text-pop-blue-700',
    },
    APPROVED: {
      label: 'Approved',
      logo: <MdOutlineCheckCircle className='h-3 w-3 text-pop-green-600' />,
      bgClass: 'bg-pop-green-50',
      textClass: 'text-pop-green-600',
    },
    CANCELLED: {
      label: 'Canceled',
      logo: <IoMdCloseCircleOutline className='h-3 w-3 text-pop-red-600' />,
      bgClass: 'bg-pop-red-100',
      textClass: 'text-pop-red-600',
    },
    REJECTED: {
      label: 'Rejected',
      logo: <IoMdCloseCircleOutline className='h-3 w-3 text-pop-red-600' />,
      bgClass: 'bg-pop-red-100',
      textClass: 'text-pop-red-600',
    },
    AUTO_DISQUALIFIED: {
      label: 'Auto-disqualified',
      logo: <MdOutlineBackHand className='h-3 w-3 text-pop-red-600' />,
      bgClass: 'bg-pop-red-100',
      textClass: 'text-pop-red-600',
    },
    SCREEN_OUT: {
      label: 'Screened Out',
      logo: <MdDoNotDisturbAlt className='h-3 w-3 text-pop-orange-400' />,
      bgClass: 'bg-pop-orange-50',
      textClass: 'text-pop-orange-400',
    },
  }

  const selectedStatus = statusMapping[status] || {
    label: enumToString(status),
    logo: null,
    bgClass: 'bg-pop-grey-100',
    textClass: 'text-pop-grey-700',
  }

  return (
    <div
      className={`flex flex-row items-center gap-1 rounded-full px-2 py-1 ${selectedStatus.bgClass}`}
    >
      {selectedStatus.logo}
      <span
        className={`text-xs font-medium ${selectedStatus.textClass}`}
        data-testid='survey-status'
      >
        {selectedStatus.label}
      </span>
    </div>
  )
}
